import { Component, OnInit, OnDestroy } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { customerConfig } from '@uxdf/direct-shared-lib';

import * as ContractsAction from '../../../../redux/actions/account/actions-contracts';
import { ContractsState } from '../../../../redux/models/account/contracts.state';
import { __config_invoice, getContractsInfo } from '../../../../redux/reducers';
import { Sorting } from '../../../../redux/models/account/sortingTypes.model';
import { GetContracts } from '../../../../redux/actions/account/actions-contracts';
import { InvoicesConfigModel } from '../../../../redux/models/invoices/invoicesConfig.model';


@Component({
  standalone: false,
  selector: 'app-contracts-download',
  templateUrl: './contracts-documents.component.html',
  styleUrls: ['./contracts-documents.component.scss']
})
export class ContractsDocumentsComponent implements OnInit, OnDestroy {
  contractsState$: Observable<ContractsState>;
  customerConfigSubscription: Subscription;
  // localize strings
  readonly accountContractsTableDate = $localize`:@@contracts-documents.accountContractsTableDate:Date`;
  readonly accountContractsContractTypeLabel = $localize`:@@contracts-documents.accountContractsContractTypeLabel:Contract type`;
  readonly accountOrdersDetailsDownloadPdf = $localize`:@@contracts-documents.accountOrdersDetailsDownloadPdf:Download PDF`;
  readonly accountContractsNoContractsLoaded = $localize`:@@contracts-documents.accountContractsNoContractsLoaded:Coming soon. Your contract will be uploaded after the renewal.`;

  invoicesConfigState$: Observable<{
    isLoading: boolean;
    config: InvoicesConfigModel;
  }>;
  /* eslint-disable */
  contractTypeTranslationMap: {} = {
    SUBSCRIBER_AGREEMENT: 'accountContractsContractTypeSubscriptionAgreement',
    PRODUCT_PROTOCOLS: 'accountContractsContractTypeProductProtocol',
    ADMINISTRATION_AGREEMENT: 'accountContractsContractTypeAdminAgreement'
  };

  constructor(private readonly store: Store<ContractsState>) {}

  ngOnInit() {
    this.customerConfigSubscription = this.store.pipe(select(customerConfig)).subscribe(response => {
      if (response.customerConfig && !response.isLoading) {
        this.invoicesConfigState$ = this.store.pipe(select(__config_invoice));
        this.store.dispatch(new GetContracts());
        this.contractsState$ = this.store.pipe(select(getContractsInfo));
      }
    });
  }

  ngOnDestroy() {
    this.customerConfigSubscription.unsubscribe();
  }

  public sort(direction) {
    direction = direction === 'ASC' ? Sorting.desc : Sorting.asc;
    this.store.dispatch(new ContractsAction.SortContractsInit(direction));
  }
}
